package com.example.mystybag.appCore.model.addMerchantLocation

/**
 * UI state for the "Menu photos" step when adding a merchant location.
 * Up to 10 photos; each item is a temp file name after crop (same flow as cover photo).
 */
data class MerchantRegistrationMenuPhotosUIState(
    val menuPhotoFileNames: List<String> = emptyList(), // Ordered list, max 10
    val isLoading: Boolean = false,
    val errorMessage: String? = null
)
